import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-forest text-cream relative overflow-hidden" data-id="element-114">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-115">
        <div className="w-20 h-20 bg-gold rounded-full flex items-center justify-center mx-auto mb-8 shadow-[0_0_30px_rgba(212,168,83,0.5)]" data-id="element-116">
          <ShieldCheck size={40} className="text-forest-dark" data-id="element-117" />
        </div>

        <h2 className="font-serif text-3xl md:text-4xl font-bold text-gold mb-4" data-id="element-118">
          Garantía Total de 30 Días
        </h2>

        <p className="text-xl md:text-2xl font-medium text-white mb-8 italic" data-id="element-119">
          Si no ves resultados, no pagas. Punto.
        </p>

        <div className="space-y-6 text-lg text-cream/90 text-left md:text-center max-w-2xl mx-auto mb-10" data-id="element-120">
          <p data-id="element-121">Aplica el protocolo durante 7 días completos.</p>
          <p data-id="element-122">
            Si al séptimo día no notas una reducción visible en tu hinchazón
            abdominal matutina, si no duermes mejor, si no te despiertas con más
            energía...
          </p>
          <p className="font-bold text-white text-xl" data-id="element-123">
            Escríbenos y te devolvemos cada centavo.
          </p>
          <p data-id="element-124">Sin preguntas. Sin formularios complicados. Sin esperas.</p>
          <p data-id="element-125">
            Porque estamos tan seguros de que este sistema funciona que el
            riesgo es completamente nuestro.
          </p>
        </div>

        <div className="bg-white/10 p-6 rounded-xl border border-gold/30 backdrop-blur-sm inline-block" data-id="element-126">
          <p className="text-lg italic text-gold" data-id="element-127">
            "Una garantía de 30 días significa que puedes probar las 21 recetas
            completas sin arriesgar absolutamente nada."
          </p>
        </div>
      </div>
    </section>;
}